import type { FC } from "react"
// import the core library.
import ReactEChartsCore from "echarts-for-react/lib/core"
// Import the echarts core module, which provides the necessary interfaces for using echarts.
import * as echarts from "echarts/core"
import { MarkLineComponent } from "echarts/components"
// Import charts, all with Chart suffix
import {
  LineChart,
  BarChart,
  PieChart,
  ScatterChart,
  RadarChart,
  // MapChart,
  TreeChart,
  TreemapChart,
  // GraphChart,
  GaugeChart,
  // FunnelChart,
  // ParallelChart,
  // SankeyChart,
  // BoxplotChart,
  // CandlestickChart,
  // EffectScatterChart,
  // LinesChart,
  // HeatmapChart,
  PictorialBarChart,
  // ThemeRiverChart,
  // SunburstChart,
  // CustomChart,
} from "echarts/charts"
// import components, all suffixed with Component
import {
  // GridSimpleComponent,
  GridComponent,
  // PolarComponent,
  RadarComponent,
  // GeoComponent,
  SingleAxisComponent,
  // ParallelComponent,
  // CalendarComponent,
  // GraphicComponent,
  // ToolboxComponent,
  TooltipComponent,
  AxisPointerComponent,
  // BrushComponent,
  TitleComponent,
  // TimelineComponent,
  // MarkPointComponent,
  // MarkLineComponent,
  // MarkAreaComponent,
  LegendComponent,
  // LegendScrollComponent,
  LegendPlainComponent,
  DataZoomComponent,
  // DataZoomInsideComponent,
  DataZoomSliderComponent,
  // VisualMapComponent,
  // VisualMapContinuousComponent,
  // VisualMapPiecewiseComponent,
  // AriaComponent,
  // TransformComponent,
  // DatasetComponent,
} from "echarts/components"
// Import renderer, note that introducing the CanvasRenderer or SVGRenderer is a required step
import {
  CanvasRenderer,
  // SVGRenderer,
} from "echarts/renderers"

// Register the required components
echarts.use([
  SingleAxisComponent,
  LegendComponent,
  LegendPlainComponent,
  AxisPointerComponent,
  TitleComponent,
  TooltipComponent,
  GridComponent,
  RadarComponent,
  DataZoomComponent,
  DataZoomSliderComponent,
  LineChart,
  PieChart,
  ScatterChart,
  BarChart,
  PictorialBarChart,
  RadarChart,
  GaugeChart,
  TreemapChart,
  TreeChart,
  CanvasRenderer,
  MarkLineComponent,
])

// The usage of ReactEChartsCore are same with above.

interface IReactEChartsContainerProps {
  option: any
  className?: string
  onChartReadyCallback?: (instance: any) => void | undefined
  // eslint-disable-next-line @typescript-eslint/ban-types
  onEvents?: Record<string, Function>
}

const ReactEChartsContainer: FC<IReactEChartsContainerProps> = ({
  className,
  option = {},
  onChartReadyCallback,
  onEvents = {},
}) => {
  return (
    <ReactEChartsCore
      className={className}
      style={{ height: "100%", width: "100%" }}
      echarts={echarts}
      option={option}
      notMerge={true}
      lazyUpdate={true}
      onChartReady={onChartReadyCallback}
      onEvents={onEvents}
    />
  )
}

export default ReactEChartsContainer
